if (!customElements.get('klaviyo-form-swap')) {
  class KlaviyoFormSwap extends HTMLElement {
    constructor() {
      super();

      this.handleSubscribed = this.handleSubscribed.bind(this);
    }

    connectedCallback() {
      this.swapGroup = this.dataset.swapGroup || '';

      if (window.Shopify && window.Shopify.designMode) {
        return this.reveal();
      }

      if (!this.swapGroup) return;

      document.addEventListener('klaviyo:subscribed', this.handleSubscribed);
    }

    disconnectedCallback() {
      document.removeEventListener('klaviyo:subscribed', this.handleSubscribed);
    }

    handleSubscribed(event) {
      if ((event.detail && event.detail.group) !== this.swapGroup) return;
      if (event.klaviyoFormSwapHandled) return;

      event.klaviyoFormSwapHandled = true;

      const sourceSection = event.target.closest('.shopify-section');
      const formSections = this.getSectionsBySelector(`klaviyo-step-form[data-swap-group]`);
      const swaps = Array.from(document.querySelectorAll('klaviyo-form-swap[data-swap-group]'))
        .filter((swap) => swap.dataset.swapGroup === this.swapGroup);
      const scrollTarget = this.getScrollTarget(swaps, sourceSection);

      formSections.forEach((section) => {
        section.hidden = true;
      });

      swaps.forEach((swap) => {
        const section = swap.closest('.shopify-section');
        if (section) section.hidden = false;

        swap.reveal(true, swap === scrollTarget);
      });
    }

    getSectionsBySelector(selector) {
      return Array.from(document.querySelectorAll(selector))
        .filter((element) => element.dataset.swapGroup === this.swapGroup)
        .map((element) => element.closest('.shopify-section'))
        .filter((section, index, sections) => section && sections.indexOf(section) === index);
    }

    getScrollTarget(swaps, sourceSection) {
      if (!sourceSection) return swaps[0];

      return swaps.find((swap) => {
        const section = swap.closest('.shopify-section');

        return section && Boolean(sourceSection.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING);
      }) || swaps[0];
    }

    reveal(animate, scroll = true) {
      if (!this.hidden) return;

      if (animate) {
        this.classList.add('is-revealed');
      }

      this.hidden = false;

      if (!scroll) return;

      const { top } = this.getBoundingClientRect();
      if (top < 0 || top > window.innerHeight) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  customElements.define('klaviyo-form-swap', KlaviyoFormSwap);
}
